module.exports = __webpack_public_path__ + "img/1550109607.122a4a0f.jpg";